<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-volume element-with-heading" id="vol-1">
<div class="heading heading-container-group heading-size-group heading-format-group heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">BE WITH ME</h1>
</div>
<div class="heading-ornament-block heading-ornament-aspect-wide">
<div class="heading-ornament-size-container">
<img alt="" class="heading-ornament-image" src="images/heading-swash-ornate-screen.png"/>
</div>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-text">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol-001.vue?0a20f21f